const apiKey = "5534f91267a74f66b5212a32ebac136d";
export default apiKey;
